import { render } from "./TheHeader.vue?vue&type=template&id=afdf7b80&scoped=true"
import script from "./TheHeader.vue?vue&type=script&lang=js"
export * from "./TheHeader.vue?vue&type=script&lang=js"

import "./TheHeader.vue?vue&type=style&index=0&id=afdf7b80&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-afdf7b80"

export default script